var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87868 13.6904C3.75736 14.6667 5.17157 14.6667 8 14.6667C10.8284 14.6667 12.2426 14.6667 13.1213 13.6904C14 12.7141 14 11.1427 14 8.00004C14 4.85734 14 3.286 13.1213 2.30968C12.2426 1.33337 10.8284 1.33337 8 1.33337C5.17157 1.33337 3.75736 1.33337 2.87868 2.30968C2 3.286 2 4.85734 2 8.00004C2 11.1427 2 12.7141 2.87868 13.6904Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 5.33333C4.66675 5.02334 4.66675 4.86835 4.70082 4.74118C4.79329 4.39609 5.06284 4.12654 5.40793 4.03407C5.5351 4 5.69009 4 6.00008 4H10.0001C10.3101 4 10.4651 4 10.5922 4.03407C10.9373 4.12654 11.2069 4.39609 11.2993 4.74118C11.3334 4.86835 11.3334 5.02334 11.3334 5.33333C11.3334 5.64332 11.3334 5.79832 11.2993 5.92549C11.2069 6.27058 10.9373 6.54013 10.5922 6.63259C10.4651 6.66667 10.3101 6.66667 10.0001 6.66667H6.00008C5.69009 6.66667 5.5351 6.66667 5.40793 6.63259C5.06284 6.54013 4.79329 6.27058 4.70082 5.92549C4.66675 5.79832 4.66675 5.64332 4.66675 5.33333Z",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.33341,
    cy: 8.66667,
    r: 0.666667,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.33341,
    cy: 11.3333,
    r: 0.666667,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99992,
    cy: 8.66667,
    r: 0.666667,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99992,
    cy: 11.3333,
    r: 0.666667,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6667,
    cy: 8.66667,
    r: 0.666667,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6667,
    cy: 11.3333,
    r: 0.666667,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.67ab616492ce15d9892a9d8e1bafc23c.svg";
export { ForwardRef as ReactComponent };